import { EventRow } from './logger.event-row';
import { loggerConstants } from './logger.constants';
import type { IExtendedTelemetryItem } from '@microsoft/1ds-analytics-web-js';

/** PerformanceEvent with custom extendable fields. */
export class CustomPerformanceEvent extends EventRow {
    constructor(
        component: string,
        operation: string,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        props: Record<string, any>
    ) {
        super(loggerConstants.Event_Performance, {
            component,
            operation,
            ...props
        });
    }

    public generateLoggingEntry(): IExtendedTelemetryItem {
        return { name: loggerConstants.Event_Performance, data: { ...this.getStringifiedProperties(), ...this.measurements } };
    }
}
